export default __webpack_public_path__ + "static/media/blank-profile.c3f94521.png";